import React from 'react';
import { ASSET_BASE_URL } from '../config/constants';

function VisualizePage({ children, serverStatus }) {
  // If connected, show the graph
  if (serverStatus === 'active') {
    return children;
  }

  // Show simple waiting message
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      width: '100%',
      padding: '40px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
    }}>
      {/* Logo in top left */}
      <a href="https://bonzai.dev" style={{
        position: 'absolute',
        top: '24px',
        left: '24px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        textDecoration: 'none'
      }}>
        <img
          src={`${ASSET_BASE_URL}/favicon.jpg`}
          alt="Bonzai"
          style={{ width: '32px', height: '32px', borderRadius: '6px' }}
        />
        <span style={{ fontSize: '20px', fontWeight: '600', color: '#333' }}>bonzai</span>
      </a>

      <div style={{
        background: '#fff',
        padding: '40px',
        borderRadius: '16px',
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.1)',
        maxWidth: '400px',
        width: '100%',
        textAlign: 'center'
      }}>
        {/* Check icon */}
        <div style={{
          width: '48px',
          height: '48px',
          borderRadius: '50%',
          background: '#22c55e',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 16px'
        }}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="white" style={{ width: '28px', height: '28px' }}>
            <path fillRule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clipRule="evenodd" />
          </svg>
        </div>

        <h2 style={{
          margin: '0 0 12px',
          fontSize: '24px',
          fontWeight: '600',
          color: '#333'
        }}>
          Almost there!
        </h2>

        <p style={{
          margin: '0 0 16px',
          fontSize: '15px',
          color: '#666',
          lineHeight: '1.6'
        }}>
          Your visualization will appear here.
        </p>

        <p style={{
          margin: '0',
          fontSize: '15px',
          color: '#666',
          lineHeight: '1.6'
        }}>
          To view, run{' '}
          <code style={{
            background: '#f3f4f6',
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '13px',
            whiteSpace: 'nowrap'
          }}>
            npx bonzai-tree -v
          </code>{' '}
          in a local repo.
        </p>
      </div>
    </div>
  );
}

export default VisualizePage;
